app.directive('closedTradeItem', [
    function () {
        return {
            restrict: 'E',
            templateUrl: 'templates/directives/closedTrade.html'
        }
    }]);